export const GET_ALL_BASIC_LOGIN_USER = `query($country: [String]!, $appName: [String]!, $first:Int, $last:Int, $after:Cursor, $before:Cursor,$filter: BasicLoginUserFilter){
  getBasicLoginUser(country:$country, appName:$appName, first:$first, last:$last, after:$after, before:$before,filter:$filter ){
      nodes{
        id
        firstName
        lastName
        country
        createdAt
        email
        username
        userType
        loginCount
        lastLogin
        failedAttempt
        lockout
        status
        expirationDateTime
        basicLoginUserPermissions
        phone
        gender
        primaryAppName
        primaryCountryName
        domainName
      }
      totalCount
      pageInfo{
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
}`;

export const CREATE_BASIC_LOGIN_USER = `mutation($basicLoginUser: BasicLoginUserInput!, $isEamil: Int!, $password: String!){
  insertAdminBasicLoginUser(input:{
    isEamil:$isEamil,
    userPassword:$password,
    basicLoginUser: $basicLoginUser
  })
  {
    boolean
  }
}`;

export const UPDATE_BASIC_LOGIN_USER = `mutation($id: UUID!, $basicLoginUserInput: BasicLoginUserInput!){
  customUpdateBasicLoginUser(input:{
    uId: $id,
    basicLogin: $basicLoginUserInput
  })
  {
    basicLoginUser {
      firstName
      lastName
      email
      username
      phone
      gender
    }
  }
}`;

export const UPDATE_STATUS = `mutation($id: UUID!, $userStatus: Int!){
  updateBasicLoginUserStatus(input:{
    uId: $id,
    userStatus: $userStatus
  })
  {
    basicLoginUser {
      id
      status
    }
  }
}`;

export const RESET_PASSWORD = `mutation($id: UUID!,$password: String!, $isEmail: Int!){
  basicLoginResetPassword(input:{
    userId:$id,
    newPassword:$password,
    isEmail: $isEmail
  })
  {
    string
  }
}`;

export const GET_BASIC_LOGIN_APPS = `
  query{ allBasicAuths(orderBy: [
    APP_NAME_ASC,
    COUNTRY_DESC
  ]){
      nodes{
        appName
        domainName
        country
      }
    }
  }`;

export const UPDATE_PERMISSION = `mutation($id: UUID!, $basicLoginUser: BasicLoginUserPatch!){
  updateBasicLoginUserById(input:{
    id:$id,
    basicLoginUserPatch:$basicLoginUser
  })
  {
    basicLoginUser{
      id
    }
  }
}`;

export const GET_AUDIT_REPORT = `query{
  allBasicLoginUserActivities{
    nodes{
      id
      userId
      action
      field
      originalValue
      newValue
      afectedUser
      section
      createdAt
      creatorUserEmail
    }
  }
}`;

export const GET_BASIC_LOGIN_EXCEL_USERS = `query($country: [String]!, $appName: [String]!, $filter: BasicLoginUserFilter){
  getBasicLoginUser(country:$country, appName:$appName, filter:$filter){
      nodes{
        id
        firstName
        lastName
        createdAt
        email
        username
        userType
        loginCount
        lastLogin
        status
        basicLoginUserPermissions
        phone
        domainName
        userByUserId{
          firstName
          lastName
        }
      }
    }
}`;
